const Download = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      d="M15.2446 16.4982C15.6589 16.4982 15.9946 16.834 15.9946 17.2482C15.9946 17.6279 15.7125 17.9417 15.3464 17.9914L15.2446 17.9982H4.75C4.33579 17.9982 4 17.6624 4 17.2482C4 16.8685 4.28215 16.5547 4.64823 16.505L4.75 16.4982H15.2446ZM10.0036 2C10.3833 2 10.6971 2.28215 10.7468 2.64823L10.7536 2.75L10.753 12.943L13.7192 9.97242C13.9852 9.70591 14.4019 9.68132 14.6957 9.8989L14.7799 9.97144C15.0464 10.2375 15.071 10.6541 14.8534 10.9479L14.7809 11.0321L10.538 15.2827L10.4674 15.3453L10.3764 15.4039L10.34 15.425L10.2488 15.4629L10.1283 15.493L10.0591 15.501L9.999 15.5029C9.94888 15.5029 9.89801 15.4974 9.84828 15.4868L9.76741 15.4637C9.6714 15.4327 9.58429 15.3824 9.51014 15.3177L5.22056 11.033C4.92746 10.7403 4.92712 10.2654 5.21981 9.97231C5.48588 9.70585 5.90253 9.68135 6.1963 9.89899L6.28047 9.97155L9.253 12.939L9.25362 2.75C9.25362 2.33579 9.58941 2 10.0036 2Z"
      fill="currentColor"
    />
  </svg>
);

export default Download;
